export const getBroadcastPort = () => {
    if (+window.location.port === 8080 || window.location.hostname === '174.138.11.32') { // local,dev
        return 6001;
    }
    return 60601; // prod
};
